import React from 'react';
import { useRecoilValue } from 'recoil';
import { userDetailAtom } from '../../../Services/_states';
import { dateFormate } from '../../../utils/helper';
import { Box, Typography, Divider } from '@mui/material';

const InfoRow: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <Box sx={{display:'flex', justifyContent:'space-between',mb:1,pb:1, borderBottom:"1px solid #E3E3E3"}}>
    <Typography
      fontWeight={500}
      sx={{
        minWidth: '60px',
        fontSize: '14px',
        fontWeight:400,
        color: '#404040',
      }}
    >
      {label}:
    </Typography>
    <Typography color="#404040" sx={{ fontSize: '14px', fontWeight:400, }}>
      {value}
    </Typography>
  </Box>
);

const UserInfo: React.FC = () => {
  const userDetails = useRecoilValue(userDetailAtom);

  return (
    <Box p={0}>
      {userDetails?.user_type && <InfoRow label="User Type" value={userDetails.user_type} />}

      {userDetails?.created_at && (
        <InfoRow
          label="Created At"
          value={dateFormate(userDetails.created_at, 'DD-MM-YYYY h:mm A')}
        />
      )}

      {userDetails?.updated_at && (
        <InfoRow
          label="Last Active"
          value={dateFormate(userDetails.updated_at, 'DD-MM-YYYY h:mm A')}
        />
      )}

      {userDetails?.payload?.city && <InfoRow label="City" value={userDetails.payload.city} />}
      {userDetails?.payload?.area && <InfoRow label="Area" value={userDetails.payload.area} />}
      {userDetails?.payload?.pincode && (
        <InfoRow label="Pincode" value={userDetails.payload.pincode} />
      )}
      {userDetails?.payload?.primary_count && (
        <InfoRow label="Primary Count" value={userDetails.payload.primary_count} />
      )}
      {userDetails?.payload?.society_name && (
        <InfoRow label="Society Name" value={userDetails.payload.society_name} />
      )}
      {userDetails?.payload?.society_type_quality && (
        <InfoRow
          label="Society Type Quality"
          value={userDetails.payload.society_type_quality}
        />
      )}
      {userDetails?.payload?.type_of_entity && (
        <InfoRow label="Type Of Entity" value={userDetails.payload.type_of_entity} />
      )}
      {userDetails?.payload?.designation && (
        <InfoRow label="Designation" value={userDetails.payload.designation} />
      )}
    </Box>
  );
};

export default UserInfo;
